import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Modal, Button } from "antd";
import { ClockCircleOutlined } from "@ant-design/icons";
import useAuthStore from "stores/useAuthStore";
import { logout as authLogout } from "auth";
import { useTranslation } from "react-i18next";
import "./SessionExpiredModal.css";

const SessionExpiredModal = () => {
  const { t } = useTranslation("login");
  const sessionExpired = useAuthStore((s) => s.sessionExpired);
  const navigate = useNavigate();

  useEffect(() => {
    if (sessionExpired) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
    return () => document.body.classList.remove("modal-open");
  }, [sessionExpired]);

  const handleGoToLogin = () => {
    const { redirectPath } = authLogout();
    navigate(redirectPath);
  };

  if (!sessionExpired) return null;

  return (
    <Modal
      open={sessionExpired}
      closable={false}
      footer={null}
      centered
      width={400}
      className="session-expired-modal"
      maskClosable={false}
    >
      <div className="session-expired-modal__content">
        <ClockCircleOutlined className="session-expired-modal__icon" />
        <h2 className="session-expired-modal__title">
          {t("session_expired_modal.title")}
        </h2>
        <p className="session-expired-modal__description">
          {t("session_expired_modal.description")}
        </p>
        <p className="session-expired-modal__description session-expired-modal__description--line2">
          {t("session_expired_modal.description_line2")}
        </p>
        <Button
          type="primary"
          size="large"
          className="session-expired-modal__button"
          onClick={handleGoToLogin}
        >
          {t("session_expired_modal.buttons.go_to_login")}
        </Button>
      </div>
    </Modal>
  );
};

export default SessionExpiredModal;
